import { generateActionForKey, generateActions } from "../generateActions";
import { eChuongTrinhDaoTaoChiTietActionsObj } from "../../action-types/ctdt/IChuongTrinhDaoTaoChiTietActionTypes";
import { NotifyHelper } from "../../../helpers/toast";

export const chuongTrinhDaoTaoChiTietActions = {
    ...generateActions(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET"),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_NHOMTUCHON_CONFIG_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_NHOMTUCHON_CONFIG_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "UPDATE_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "ADD_SUCCESS", () => { NotifyHelper.Success("Thêm thành công") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "ADD_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "DELETE_SUCCESS", () => { NotifyHelper.Success("Xóa thành công") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "DELETE_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "SAVE_RANGBUOC_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "SAVE_RANGBUOC_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "DELETE_RANGBUOC_SUCCESS", () => { NotifyHelper.Success("Đã xóa") }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoChiTietActionsObj, "CHUONG_TRINH_DAO_TAO_CHI_TIET",
        "DELETE_RANGBUOC_ERROR", (m) => { NotifyHelper.Error(m.data) }
    ),
}